import { render, staticRenderFns } from "./blankLayout.vue?vue&type=template&id=a2125e4a&scoped=true&"
import script from "./blankLayout.vue?vue&type=script&lang=js&"
export * from "./blankLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2125e4a",
  null
  
)

export default component.exports